import { datadogRum } from '@datadog/browser-rum';
import { appVersion, env, isDev } from '~/env';

export const configureDatadogRum = () => {
  // Can be removed to debug RUM metrics locally if necessary
  if (isDev() || env.VITE_APP_ENV === 'sandbox') {
    return;
  }

  datadogRum.init({
    applicationId: env.VITE_DATADOG_APPLICATION_ID,
    clientToken: env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'jane-discovery-web',
    env: env.VITE_APP_ENV,
    version: appVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.setGlobalContext({
    app: {
      name: 'jane-discovery-web',
      version: appVersion,
    },
  });
};

// Tracks our events using DataDog RUM in addition to RudderStack
export const trackRumEvent = (
  name: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  properties: Record<string, any> = {}
) => {
  datadogRum.addAction(name, properties);
};
